import config from "@/config";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { Routes } from "@/features/router";
import { useAppSelector } from "@/redux/hooks";
import { getListOfCompanies } from "@/redux/slices/userSlice";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateCompanyRoutes = () => {
  const { leUuid } = useCompanyContext();
  if (!config.ACTIVATE_OLKYPASS_PRO) return <Navigate to={Routes.dashboard} replace />;
  const linkedCompanies = useAppSelector(getListOfCompanies);

  const isLinked = (() =>
    leUuid !== null && linkedCompanies && Object.keys(linkedCompanies).includes(leUuid))();

  return isLinked ? <Outlet /> : <Navigate to={Routes.dashboard} replace />;
};
